// Get severity color for alerts
export const getSeverityColor = (priority: number, isResolved: boolean = false): string => {
  if (isResolved) return 'bg-green-500';
  if (priority === 1) return 'bg-red-500';
  if (priority === 2) return 'bg-orange-500';
  return 'bg-gray-500';
};

// Format timestamp to human-readable format with timezone
export const formatTimestamp = (timestamp: string): string => {
  try {
    // Check if it's a time range (contains " - ")
    if (timestamp.includes(' - ')) {
      const parts = timestamp.split(' - ');
      const startDate = new Date(parts[0]);
      const endTime = parts[1];

      // Format start time
      const startFormatted = startDate.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      });

      // Extract just the time from end timestamp
      const endDate = new Date(endTime.includes('T') ? endTime : `${parts[0].split('T')[0]}T${endTime}`);
      const endTimeFormatted = endDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      });

      return `${startFormatted} - ${endTimeFormatted}`;
    }

    // Single timestamp
    const date = new Date(timestamp);

    // Check if date is invalid
    if (isNaN(date.getTime())) {
      return timestamp;
    }

    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short'
    });
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return timestamp; // Return original if formatting fails
  }
};
